<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title>
            Artikel Gruppe Erstellen
          </v-card-title>
          <v-card-text>
            <BundleItemGroupForm :type="'create'" :form="form" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Admin'
import BundleItemGroupForm from '../../../../Components/Admin/Item/ItemGroup/Form.vue'

export default {
   components: { BundleItemGroupForm },
   layout: (h, page) => h(Layout, [page]),
   data: function () {
      return {
         form: this.$inertia.form({
            name: ''
         })
      }
   }
}
</script>

<style lang="scss" scoped>

</style>
